"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoop = void 0;
const react_1 = __importDefault(require("react"));
const react_spring_1 = require("react-spring");
function useBoop({ x = 0, y = 0, rotation = 0, scale = 1, timing = 150, springConfig = {
    tension: 300,
    friction: 10,
}, delay = 0, }) {
    // const prefersReducedMotion = usePrefersReducedMotion()
    const [isBooped, setIsBooped] = react_1.default.useState(false);
    const style = (0, react_spring_1.useSpring)({
        from: {
            transform: isBooped
                ? `translate(0px, 0px)
			rotate(0deg)
			scale(1)`
                : `translate(${x}px, ${y}px)
			rotate(${rotation}deg)
			scale(${scale})`,
        },
        to: {
            transform: isBooped
                ? `translate(${x}px, ${y}px)
			rotate(${rotation}deg)
			scale(${scale})`
                : `translate(0px, 0px)
			rotate(0deg)
			scale(1)`,
        },
        config: springConfig,
        delay: delay,
    });
    react_1.default.useEffect(() => {
        if (!isBooped) {
            return;
        }
        const timeoutId = window.setTimeout(() => {
            setIsBooped(false);
        }, timing);
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [isBooped]);
    const trigger = react_1.default.useCallback(() => {
        setIsBooped(true);
    }, []);
    // let appliedStyle = prefersReducedMotion ? {} : style
    let appliedStyle = style;
    return { style: appliedStyle, trigger };
}
exports.useBoop = useBoop;
const Boop = (_a) => {
    var { children } = _a, boopConfig = __rest(_a, ["children"]);
    const { style, trigger } = useBoop(boopConfig);
    return (react_1.default.createElement(react_spring_1.animated.span, { onMouseEnter: trigger, style: style }, children));
};
exports.default = Boop;
